import { library } from '@fortawesome/fontawesome-svg-core';

// Selective imports for Pro Light icons (fal)
import {
  faInfoCircle,
  faPlusCircle,
  faTrash,
  faEdit,
  faAngleLeft,
  faTimes,
  faCheck,
  faClock,
  faSync,
  faArrowLeft,
  faBars,
  faStar,
  faFilter,
  faCalendarPlus,
  faTimesCircle,
  faCheckCircle,
  faUser,
  faUsers,
  faUserPlus,
  faCirclePlus,
  faStickyNote,
  faImage,
  faList,
  faHome,
  faUserGroup,
  faNoteSticky,
  faEnvelope,
  faChartLine,
  faDollarSign,
  faDownload,
  faGift,
  faChartBar,
  faEye,
  faSun,
  faSearch,
  faCopy,
  faBullhorn,
  faShareNodes,
  faShare,
  faShieldCheck,
  faHeart,
  faAward,
  faBuilding,
  faBriefcase,
  faUserCheck,
  faChevronRight,
  faRedo,
  faSparkles,
  faCode,
  faHandshake,
  faShoppingBag,
  faShoppingCart,
  faTicket,
  faTrophy,
  faBox,
  faWallet,
  faExchangeAlt,
  faSave,
  faFileExport,
  faComments,
  faExclamationTriangle,
  faEllipsisVertical,
  faHistory,
  faFileText,
  faCircleQuestion,
  faRightFromBracket,
  faRightToBracket,
  faHandHoldingHeart,
  faGripVertical,
  faCloudUploadAlt,
  faCalendarAlt,
  faMapMarkerAlt,
  faBell,
  faPaperPlane,
  faExclamationCircle,
  faSearchPlus,
  faSearchMinus,
  faExternalLinkAlt,
  faImages as falImages,
  faKey,
  faTag,
  faChevronDown,
  faLightbulb,
  faRocket,
  faBookOpen,
  faArrowUp,
  faArrowDown,
  faPlus as falPlus,
  faGear as falGear,
} from '@fortawesome/pro-light-svg-icons';

// Selective imports for Free Solid icons (fas)
import {
  faFileImage,
  faImages,
  faPlus,
  faGripVertical as fasGripVertical,
  faUpload,
  faFloppyDisk,
  faRepeat,
  faGear,
  faArrowRightFromBracket,
  faUserGroup as fasUserGroup,
  faNoteSticky as fasNoteSticky,
  faEnvelope as fasEnvelope,
  faChartLine as fasChartLine,
  faSignOutAlt,
  faCog,
  faUsers as fasUsers,
  faUser as fasUser,
  faClock as fasClock,
  faUserPlus as fasUserPlus,
  faCirclePlus as fasCirclePlus,
  faStickyNote as fasStickyNote,
  faImage as fasImage,
  faList as fasList,
  faHome as fasHome,
  faDownload as fasDownload,
  faGift as fasGift,
  faChartBar as fasChartBar,
  faTrash as fasTrash,
  faStar as fasStar,
  faArrowLeft as fasArrowLeft,
  faEye as fasEye,
  faSun as fasSun,
  faShare as fasShare,
  faShield as fasShieldCheck,
  faWallet as fasWallet,
  faCheckCircle as fasCheckCircle,
} from '@fortawesome/free-solid-svg-icons';

import FontAwesomeIcon from './FontAwesomeIcon.vue';

// Add only the icons we actually use
library.add(
  // Pro Light icons
  falImages,
  falGear,
  faKey,
  faLightbulb,
  faRocket,
  faBookOpen,
  faTag,
  faChevronDown,
  faArrowUp,
  faArrowDown,
  falPlus,
  faInfoCircle,
  faPlusCircle,
  faTrash,
  faEdit,
  faAngleLeft,
  faTimes,
  faCheck,
  faClock,
  faSync,
  faArrowLeft,
  faBars,
  faStar,
  faFilter,
  faCalendarPlus,
  faTimesCircle,
  faCheckCircle,
  faUser,
  faUsers,
  faUserPlus,
  faCirclePlus,
  faStickyNote,
  faImage,
  faList,
  faHome,
  faUserGroup,
  faNoteSticky,
  faEnvelope,
  faChartLine,
  faDollarSign,
  faDownload,
  faGift,
  faChartBar,
  faEye,
  faSun,
  faSearch,
  faCopy,
  faBullhorn,
  faShareNodes,
  faShare,
  faShieldCheck,
  faHeart,
  faAward,
  faBuilding,
  faBriefcase,
  faUserCheck,
  faChevronRight,
  faRedo,
  faSparkles,
  faCode,
  faHandshake,
  faShoppingBag,
  faShoppingCart,
  faTicket,
  faTrophy,
  faBox,
  faWallet,
  faExchangeAlt,
  faSave,
  faFileExport,
  faComments,
  faExclamationTriangle,
  faEllipsisVertical,
  faHistory,
  faFileText,
  faCircleQuestion,
  faRightFromBracket,
  faRightToBracket,
  faHandHoldingHeart,
  faGripVertical,
  faCloudUploadAlt,
  faCalendarAlt,
  faMapMarkerAlt,
  faBell,
  faPaperPlane,
  faExclamationCircle,
  faSearchPlus,
  faSearchMinus,
  faExternalLinkAlt,

  // Free Solid icons
  faFileImage,
  faImages,
  faPlus,
  fasGripVertical,
  faUpload,
  faFloppyDisk,
  faRepeat,
  faGear,
  faArrowRightFromBracket,
  fasUserGroup,
  fasNoteSticky,
  fasEnvelope,
  fasChartLine,
  faSignOutAlt,
  faCog,
  fasUsers,
  fasUser,
  fasClock,
  fasUserPlus,
  fasCirclePlus,
  fasStickyNote,
  fasImage,
  fasList,
  fasHome,
  fasDownload,
  fasGift,
  fasChartBar,
  fasTrash,
  fasStar,
  fasArrowLeft,
  fasEye,
  fasSun,
  fasShare,
  fasShieldCheck,
  fasWallet,
  fasCheckCircle,
);

// Manually add solid shield icon with the shield-check name for menu consistency
library.add({
  prefix: 'fas',
  iconName: 'shield-check',
  icon: fasShieldCheck.icon,
});

export default FontAwesomeIcon;
